<template>
  <OutreachContactTopReaction
    v-if="props.type === 'topReaction'"
    :contact="props.contact"
  />

  <OutreachContactEngagement
    v-else-if="props.type === 'avgEngagement'"
    :contact="props.contact"
  />
</template>

<script setup lang="ts">
import OutreachContactEngagement from "shared/components/Outreach/OutreachContact/OutreachContactEngagement.vue";
import OutreachContactTopReaction from "shared/components/Outreach/OutreachContact/OutreachContactTopReaction.vue";
import type { OutreachContactStatProps } from "shared/composables/useOutreachContactSocialStats";

const props = defineProps<OutreachContactStatProps>();
</script>
